import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MotivoPerdaVendaExibicaoFormComponent } from '../exibicao';
import { MotivoPerdaVendaPLMFormComponent } from '../plm';
import { MotivoPerdaVendaOportunidadeFormComponent } from '../oportunidade/form/motivo-perda-venda-oportunidade-form.component';
import { MotivoPerdaVendaConcorrenteFormComponent } from '../concorrente/form/motivo-perda-venda-concorrente-form.component';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService } from '../../../core';

import { MotivoPerdaVenda } from '../motivo-perda-venda';
import { MotivoPerdaVendaCrudHttpService } from '../services';

@Component({
    selector: 'sgt-motivo-perda-venda-form',
    templateUrl: './motivo-perda-venda-form.component.html',
    styleUrls: ['./motivo-perda-venda-form.component.less']
})
export class MotivoPerdaVendaFormComponent implements BaseForm<MotivoPerdaVenda>, OnInit {
    entity: MotivoPerdaVenda;
    editMode: boolean;
    @ViewChild('form') form: NgForm;
    @ViewChild('exibicaoForm') exibicaoForm: MotivoPerdaVendaExibicaoFormComponent;
    @ViewChild('plmForm') plmForm: MotivoPerdaVendaPLMFormComponent;
    @ViewChild('oportunidadeForm') oportunidadeForm: MotivoPerdaVendaOportunidadeFormComponent;
    @ViewChild('concorrenteForm') concorrenteForm: MotivoPerdaVendaConcorrenteFormComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private MotivoPerdaVendaHttpCrudService: MotivoPerdaVendaCrudHttpService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        })
    }

    load(id: number) {
        this.MotivoPerdaVendaHttpCrudService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar o motivo', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new MotivoPerdaVenda();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }

    /** Verifica se o cadastro do motivo está válido */
    private isValid(): boolean {
        // Exibição
        if (this.exibicaoForm && !this.exibicaoForm.isValid()) {
            return false;
        }

        // Ciclo de Vida do Produto (PLM)
        if (this.plmForm && !this.plmForm.isValid()) {
            return false;
        }

        if (this.oportunidadeForm && !this.oportunidadeForm.isValid()) {
            return false;
        }

        if (this.concorrenteForm && !this.concorrenteForm.isValid()) {
            return false;
        }

        return true;
    }


    save() {
        if (!this.isValid()) {
            return false;
        }

        this.baseFormService.save<MotivoPerdaVenda>(this.entity, this.form, this.editMode, this.MotivoPerdaVendaHttpCrudService)
            .then(entity => {
                this.messageService.success('', 'Motivo salvo com sucesso');
                this.afterSave(entity);
            })
            .catch(error => {});
    }

    afterSave(entity: MotivoPerdaVenda) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
